import styles from "./TextareaCustom.module.scss";

const TextareaCustom = ({
  name,
  value,
  placeholder,
  onChange,
  onBlur,
  rows,
  readOnly,
  style,
}) => {
  return (
    <div className={styles.container}>
      <textarea
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        rows={rows}
        readOnly={readOnly}
        style={style}
      />
    </div>
  );
};

export default TextareaCustom;
